<template>
  <div class="h5-wrap main">
    <h3 class="title">
      疫情防控人脸测温平台
    </h3>
    <img class="title-img" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/title.png" alt="">
    <div class="link-main">
      <a class="link bg-btn-5" @click="toIntroduce">
        <img style="width:.35rem;margin-right:.32rem" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon5.png" alt="">
        产品介绍</a>
      <div class="link bg-btn-4" @click="toFakePersonForm">
        <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon1.png" alt="">
        防疫健康打卡</div>
      <div class="link bg-btn-2" @click="jumoToPage('https://news.qq.com/zt2020/page/feiyan.htm', 1)"><img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon2.png" alt="">疫情动态</div>
      <div class="link bg-btn-3" @click="jumoToPage('http://2019ncov.nosugartech.com/?scene=2&clicktime=1580254090&enterid=1580254090&from=groupmessage&isappinstalled=0', 2)" href="">
      <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon3.png" alt="">确诊患者同行程查询</div>
      <div class="link bg-btn-1" @click="jumoToPage('https://ncov.html5.qq.com/community?channelid=17&from=groupmessage&isappinstalled=&jump_from=F2OB5DIbI_dn1doDSBiPt0eY&seqno=HF1OrJobcH5kFpgy2PGfFrnl', 3)">
      <img src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/icon4.png" alt="">确诊患者小区查询</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data() {
    return {
      miniapp: false
    }
  },
  created () {
    this.miniapp = this.$router.history.current.query.miniapp === 'true'
  },
  methods: {
    toIntroduce() {
      this.$router.push('/h5/introduce_detail')
    },
    toFakePersonForm() {
      this.$router.push('/h5/fake_personform')
    },
    jumoToPage (route, pageItem) {
      if (this.miniapp) {
        this.$router.push(`/h5/fake_tools?page=${pageItem}`)
      } else {
        window.open(route, '_blank');
      }
    }
  }
}
</script>
<style scoped lang="scss">
.main {
  padding: .4rem .3rem;
  background: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg.png') no-repeat center top / 100% 100%;
  h3 {
    margin: 0;
    // font-family: "YouSheBiaoTiHei";
    font-weight: bold;
    font-size: .20rem;
    text-align: center;
    font-style: italic;
    color: #fff;
    letter-spacing: 0;
  }
  .title-img {
    width: 100%;
    margin: .15rem 0 .5rem;
  }
  .link {
    height: .9rem;
    margin-bottom: .2rem; 
    padding-left: .32rem;
    font-family: "PingFangSC-Medium";
    font-size: .19rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    text-decoration: none;
    align-items: center;
    color: #fff;
    img {
      width: .4rem;
      margin-right: .27rem;
    }
  }
}
.link-main {
  width: 3.1rem;
  margin: 0 auto;
}
.bg-btn-1 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-1.png')
}
.bg-btn-2 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-2.png')
}
.bg-btn-3 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-3.png')
}
.bg-btn-4 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-4.png')
}
.bg-btn-5 {
  background-image: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg-btn-5.png')
}
</style>